module.exports = __webpack_public_path__ + "assets/img/order_list.8825dfde.png";